import React, { useEffect, useState } from 'react';
import { EmissionDate, ReportingTable, PageContainer, DeleteModal, SiteSelect } from './component/Table';
import { columnDefinitionEnergyPurchase } from './component/Table/column';
import { FiPlus, FiTrash } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import axios from 'axios';
import * as types from "./reportData.json"

const ReportEnergyPurchase = () => {
  // const data = MOCK_DATA_Stationary_Fuels_2;
  const column = columnDefinitionEnergyPurchase;
  const navigate = useNavigate();
  const location = useLocation();
  const {bypassModal} = (location.state === null ? false : location.state)
  const axiosPrivate = useAxiosPrivate();
  const {malaysiaRegion} = types

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showContentModal, setShowContentModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalMode, setModalMode] = useState(null); // 'add' or 'edit'
  const [editableData, setEditableData] = useState({
    emissionDate: '',
    reportBy: '',
    energyType: 'Electricity',
    consumption: 0,
    energyGeneration: 0,
    scope1: 0,
    scope2: 0,
    country: '',
    region: '',
    description: '',
  });
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [rowToDelete, setRowToDelete] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axiosPrivate.get(
          '/energyPurchase/read-S2CA-records',
          {
            signal: controller.signal,
          }
        );

        if (isMounted) {
          setData(response.data);
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          // Log for debugging purposes
          // console.log('Request cancelled:', err.message);
        } else {
          console.error('Request failed:', err);
          // Only navigate if the error was not a cancellation
          // Check for a 403 status code specifically
          if (err.response && err.response.status === 403) {
            navigate('/sign-in', { state: { from: location }, replace: true });
          }
        }
      }
      setIsLoading(false);
    };

    fetchData();
    
    if (bypassModal == true){
      handleAddNewClick()
    }
    
    return () => {
      isMounted = false;
      controller.abort();
      // console.log('Cleanup: Cancelled any ongoing requests.');
    };
  }, [navigate, location, axiosPrivate]);

  const handleAddNewClick = () => {
    setEditableData({
      emissionDate: '',
      reportBy: '',
      energyType: 'Electricity',
      consumption: 0,
      energyGeneration: 0,
      scope1: 0,
      scope2: 0,
      country: '',
      region: '',
      description: '',
    });
    setModalMode('add');
    setShowContentModal(true);
  };

  const handleDeleteClick = () => {
    if (selectedRows.size > 0) {
      setShowDeleteModal(true);
    } else {
      alert('No rows selected'); // Or show a more user-friendly message
    }
  };

  const requestRowDeletion = (rowId) => {
    setRowToDelete(rowId);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (rowToDelete !== null) {
      let isMounted = true;
      const controller = new AbortController();

      try {
        await axiosPrivate.delete(`/energyPurchase/delete-S2CA-record/${rowToDelete}`, {
          headers: { 'Content-Type': 'application/json' },
          signal: controller.signal,
        });

        if (isMounted) {
          // Update the state to reflect the deletion
          setData((prevData) =>
            prevData.filter((row) => row.id !== rowToDelete)
          );
          setRowToDelete(null);
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error('Deletion failed:', err);
          if (err.response) {
            // Redirect on 403 Forbidden or show an error message
            if (err.response.status === 403) {
              navigate('/sign-in', {
                state: { from: location },
                replace: true,
              });
            } else {
              alert(
                `Error: ${err.response.data.message || 'An error occurred.'}`
              );
            }
          }
        }
      } finally {
        if (isMounted) {
          setShowDeleteModal(false); // Close the modal upon completion or error
        }
      }

      // Cleanup function to prevent state updates if the component unmounts
      return () => {
        isMounted = false;
        controller.abort();
      };
    } else {
      // If rowToDelete is null, just close the modal
      setShowDeleteModal(false);
    }
  };

  const deleteSelectedRows = async () => {
    // Check if any rows are selected for deletion
    if (selectedRows.size > 0) {
      let isMounted = true;
      const controller = new AbortController();

      try {
        const recordIdsToDelete = Array.from(selectedRows);

        await axiosPrivate.delete('/energyPurchase/delete-S2CA-records', {
          data: { ids: recordIdsToDelete }, // Sending user IDs in the request body
          headers: { 'Content-Type': 'application/json' },
          signal: controller.signal,
        });

        if (isMounted) {
          // Filter out the deleted users from the current data
          setData((prevData) =>
            prevData.filter((row) => !selectedRows.has(row.id))
          );
          setSelectedRows(new Set()); // Clear selected rows after successful deletion
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error('Deletion failed:', err);
          if (err.response) {
            // Handle specific HTTP status codes here
            if (err.response.status === 403) {
              navigate('/sign-in', {
                state: { from: location },
                replace: true,
              });
            } else {
              alert(
                `Error: ${err.response.data.message || 'An error occurred.'}`
              );
            }
          }
        }
      } finally {
        if (isMounted) {
          setShowDeleteModal(false); // Close the modal upon completion or error
        }
      }

      // Cleanup function to prevent state updates if the component unmounts
      return () => {
        isMounted = false;
        controller.abort();
      };
    } else {
      // If no rows were selected, just close the modal
      setShowDeleteModal(false);
    }
  };

  // Function to handle edit requests
  const handleEditClick = (rowData) => {
    setEditableData(rowData);
    setModalMode('edit');
    setShowContentModal(true);
  };

  const handleAddNewSubmit = async (event) => {
    event.preventDefault();

    const endpoint =
      modalMode === 'edit'
        ? `/energyPurchase/edit-S2CA-record/${editableData.id}`
        : '/energyPurchase/create-S2CA-record';
    const method = modalMode === 'edit' ? 'patch' : 'post';

    // Prepare the data payload
    const payload = {
      scope: 2,
      category: "energyPurchase",
      emissionDate: editableData.emissionDate,
      reportBy: editableData.reportBy,
      energyType: editableData.energyType,
      consumption: editableData.consumption,
      energyGeneration: editableData.energyGeneration,
      scope1: editableData.scope1,
      scope2: editableData.scope2,
      country: editableData.country,
      region: editableData.region,
      description: editableData.description,
      siteId: editableData.siteId,
    };

    try {
      const response = await axiosPrivate[method](endpoint, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      // Update the state based on the modal mode
      if (modalMode === 'edit') {
        setData((currentData) =>
          currentData.map((item) =>
            item.id === editableData.id ? { ...item, ...response.data } : item
          )
        );
      } else {
        setData((currentData) => [...currentData, response.data]);
      }

      // Reset form and close modal
      setEditableData({
        emissionDate: '',
        reportBy: '',
        energyType: 'Electricity',
        consumption: 0,
        energyGeneration: 0,
        scope1: 0,
        scope2: 0,
        country: '',
        region: '',
        description: '',
      });
      setShowContentModal(false);
    } catch (err) {
      if (!axios.isCancel(err)) {
        console.error('Submission failed:', err);
        const errorMsg = err.response?.data.message || 'An error occurred.';
        if (err.response?.status === 403) {
          navigate('/sign-in', { state: { from: location }, replace: true });
        } else {
          alert(`Error: ${errorMsg}`);
        }
      }
    }
  };

  if (isLoading) {
    return <div>Loading...</div>; // Or any loading spinner
  }

  return (
    <PageContainer
      title="Energy Purchases Reporting"
      onAdd={handleAddNewClick}
      onDelete={handleDeleteClick}
    >
      {/* {showContentModal && <MyModal onClose={() => setShowContentModal(false)} />} */}
      <ReportingTable
        data={data}
        columns={column}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        onRequestDelete={requestRowDeletion}
        onEdit={handleEditClick}
      />
      {showDeleteModal && (
        <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={(row) => (row !== null ? confirmDelete() : deleteSelectedRows())}
        rowToDelete={rowToDelete}
      />
      )}
      {showContentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex justify-center items-center p-4">
          <div className="bg-white dark:bg-gray-800 w-full max-w-lg mx-auto rounded shadow-lg overflow-hidden p-6 max-h-[90vh] overflow-y-auto">
            <h2 className="text-lg font-semibold mb-4">
              {modalMode === 'edit' ? 'Edit Data' : 'Add New Data'}
            </h2>
            <form onSubmit={handleAddNewSubmit}>
              {/* Emission Date Input */}
              <EmissionDate data={editableData} setEditableData = {setEditableData}/>

              {/* Site Select */}
              <SiteSelect 
                 value={editableData.siteId} 
                 onChange={(val) => setEditableData({ ...editableData, siteId: val })} 
                 required 
              />

              {/* Report By Dropdown */}
              <div className="mb-4">
                <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                  Report By
                </label>
                <select
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  value={editableData.reportBy}
                  onChange={(e) =>
                    setEditableData({
                      ...editableData,
                      reportBy: e.target.value,
                      consumption: 0,
                      energyGeneration: 0,
                      scope1: 0,
                      scope2: 0,
                      country: '',
                      region: '',
                    })
                  }
                  required
                >
                  <option value="">Select Type</option>
                  <option value="Supplier-Specific Method">Supplier-Specific Method (Market-based)</option>
                  <option value="Grid-Average Method">Grid-Average Method (Location-based)</option>
                </select>
              </div>

              {/* Energy Type Dropdown */}
              {editableData.reportBy === "Supplier-Specific Method" && (
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                    Energy Type
                  </label>
                  <select
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    value={editableData.energyType}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        energyType: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="">Select Energy Type</option>
                    <option value="Electricity">Electricity</option>
                    <option value="Steam">Steam</option>
                    <option value="Heating">Heating</option>
                    <option value="Cooling">Cooling</option>
                  </select>
                </div>
              )}

              {/* Location Dropdown */}
              {editableData.reportBy === "Grid-Average Method" && (
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                    Country
                  </label>
                  <select
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    value={editableData.country}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        country: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="">Select Location</option>
                    <option value="Malaysia">Malaysia</option>
                  </select>
                </div>
              )}

              {/* Region Dropdown */}
              {editableData.reportBy === "Grid-Average Method" && (
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                    Region
                  </label>
                  <select
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    value={editableData.region}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        region: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="">Select Region</option>
                    {malaysiaRegion.map((region) => (
                      <option key={region} value={region}>{region}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Scope 1 Input */}
              {editableData.reportBy === "Supplier-Specific Method" && (
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                    Supplier Scope 1 (kg CO2e)
                  </label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    value={editableData.scope1}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        scope1: e.target.value,
                      })
                    }
                    required
                  />
                </div>
              )}

              {/* Scope 2 Input */}
              {editableData.reportBy === "Supplier-Specific Method" && (
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                    Supplier Scope 2 (kg CO2e)
                  </label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    value={editableData.scope2}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        scope2: e.target.value,
                      })
                    }
                    required
                  />
                </div>
              )}

              {/* Energy Generation Input */}
              {editableData.reportBy === "Supplier-Specific Method" && (
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                    Total Energy Generation (kWh)  
                  </label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    value={editableData.energyGeneration}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        energyGeneration: e.target.value,
                      })
                    }
                    required
                  />
                </div>
              )}

              {/* Consumption Input */}
              {editableData.reportBy && (
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                    {editableData.reportBy === "Supplier-Specific Method" ? "Total Energy Consumption (kWh)" : "Total Electricity Consumption (kWh)"}
                  </label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    value={editableData.consumption}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        consumption: e.target.value,
                      })
                    }
                    required
                  />
                </div>
              )}

              {/* Description Input */}
              <div className="mb-4">
                <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                  Description
                </label>
                <textarea
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  value={editableData.description}
                  onChange={(e) =>
                    setEditableData({
                      ...editableData,
                      description: e.target.value,
                    })
                  }
                  // required
                />
              </div>

              <div className="flex justify-end mt-4">
                <button
                  type="button"
                  onClick={() => setShowContentModal(false)}
                  className="bg-gray-300 dark:bg-gray-600 dark:text-gray-200 px-4 py-2 rounded mr-2"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </PageContainer>
  );
};

export default ReportEnergyPurchase;
